import { render } from "./AddZombieModal.vue?vue&type=template&id=0c50e4ce"
import script from "./AddZombieModal.vue?vue&type=script&lang=js"
export * from "./AddZombieModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__